import React, { FC } from 'react';
import { IconProps } from '../../@types/ui';

const BellIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00195 17H5.60636C4.34793 17 3.71872 17 3.58633 16.9023C3.4376 16.7925 3.40126 16.7277 3.38515 16.5436C3.37082 16.3797 3.75646 15.7486 4.52776 14.4866C5.32411 13.1835 6.00031 11.2862 6.00031 8.6C6.00031 7.11479 6.63245 5.69041 7.75766 4.6402C8.88288 3.59 10.409 3 12.0003 3C13.5916 3 15.1177 3.59 16.2429 4.6402C17.3682 5.69041 18.0003 7.11479 18.0003 8.6C18.0003 11.2862 18.6765 13.1835 19.4729 14.4866C20.2441 15.7486 20.6298 16.3797 20.6155 16.5436C20.5994 16.7277 20.563 16.7925 20.4143 16.9023C20.2819 17 19.6527 17 18.3943 17H15.0003M9.00195 17L9.00031 18C9.00031 19.6569 10.3435 21 12.0003 21C13.6572 21 15.0003 19.6569 15.0003 18V17M9.00195 17H15.0003"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CalendarAddIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(2 2)"
      >
        <path d="m2.5.5h12c1.1045695 0 2 .8954305 2 2v12c0 1.1045695-.8954305 2-2 2h-12c-1.1045695 0-2-.8954305-2-2v-12c0-1.1045695.8954305-2 2-2z" />
        <path d="m.5 4.5h16" />
        <path d="m8.5 7.5v6.056" />
        <path d="m8.5 7.5v6" transform="matrix(0 1 -1 0 19 2)" />
      </g>
    </svg>
  );
};

const CalendarAgendaIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(4 3)"
      >
        <path d="m12.5 12.5v-10c0-1.1045695-.8954305-2-2-2h-8c-1.1045695 0-2 .8954305-2 2v10c0 1.1045695.8954305 2 2 2h8c1.1045695 0 2-.8954305 2-2z" />
        <path d="m5.5 4.5h5" />
        <path d="m2.5 4.5h1" />
        <path d="m5.5 7.5h5" />
        <path d="m2.5 7.5h1" />
        <path d="m5.5 10.5h5" />
        <path d="m2.5 10.5h1" />
      </g>
    </svg>
  );
};

const CalendarDateIcon: FC<IconProps> = ({ width, height }) => {
  return (
    // <svg
    //   className={`w-${width} h-${height}`}
    //   viewBox="0 0 21 21"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    <svg
      className={`w-${width} h-${height}`}
      version="1.1"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m4.5 2.5h12c1.1046 0 2 0.89543 2 2v11.99c0 1.1046-0.89543 2-2 2h-12c-1.1046 0-2-0.89543-2-2v-11.99c0-1.1046 0.89543-2 2-2z"
        fill="none"
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m2.659 6.5h15.841"
        fill="none"
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <text
        transform="matrix(1.9103 0 0 2.1955 -4.8372 -11.779)"
        textAnchor="middle"
        fill="currentcolor"
        fontFamily="sans-serif"
        fontSize="1.05px"
      >
        <tspan x="8" y="12.871582">
          <tspan
            fontFamily="sans-serif"
            fontSize="5.04px"
            fontWeight="bold"
            textAnchor="middle"
          >
            24
          </tspan>
        </tspan>
      </text>
    </svg>
  );
};

const CalendarDayIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd" transform="translate(2 2)">
        <path
          d="m2.5.5h12.0269119c1.1045695 0 2 .8954305 2 2v11.9907459c0 1.0543618-.8158778 1.9181651-1.8507376 1.9945143l-.1588615.0054627-12.02691193-.0577246c-1.10080997-.0052835-1.99040087-.8991544-1.99040087-1.999977v-11.9330213c0-1.1045695.8954305-2 2-2z"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m.5 4.5h16.027"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="4.5" cy="8.5" fill="currentcolor" r="1" />
      </g>
    </svg>
  );
};

const CalendarMonthIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd" transform="translate(2 2)">
        <path
          d="m2.5.5h12c1.1045695 0 2 .8954305 2 2v12c0 1.1045695-.8954305 2-2 2h-12c-1.1045695 0-2-.8954305-2-2v-12c0-1.1045695.8954305-2 2-2z"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m.5 4.5h16"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g fill="currentcolor">
          <circle cx="8.5" cy="8.5" r="1" />
          <circle cx="4.5" cy="8.5" r="1" />
          <circle cx="12.5" cy="8.5" r="1" />
          <circle cx="8.5" cy="12.5" r="1" />
          <circle cx="4.5" cy="12.5" r="1" />
          <circle cx="12.5" cy="12.5" r="1" />
        </g>
      </g>
    </svg>
  );
};

const CalendarWeekIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(2 2)"
      >
        <path d="m2.5.5h12c1.1045695 0 2 .8954305 2 2v12c0 1.1045695-.8954305 2-2 2h-12c-1.1045695 0-2-.8954305-2-2v-12c0-1.1045695.8954305-2 2-2z" />
        <path d="m.5 4.5h16" />
        <path d="m3.5 7.5v6" />
        <path d="m5.5 7.5v6" />
        <path d="m7.5 7.5v6" />
        <path d="m9.5 7.5v6" />
        <path d="m11.5 7.5v6" />
        <path d="m13.5 7.5v6" />
      </g>
    </svg>
  );
};
const CalendarBackIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      version="1.1"
      id="left"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31.418 31.418"
    >
      <g>
        <path
          d="M26.585,3v25.418c0,1.155-0.664,2.208-1.707,2.707c-0.412,0.194-0.854,0.293-1.293,0.293c-0.672,0-1.34-0.228-1.883-0.665
		L5.949,18.044c-0.706-0.569-1.116-1.428-1.116-2.335c0-0.907,0.41-1.766,1.116-2.335L21.703,0.665
		c0.899-0.726,2.135-0.868,3.178-0.372C25.921,0.792,26.585,1.844,26.585,3z"
        />
      </g>
    </svg>
  );
};
const CalendarForwardIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      version="1.1"
      id="right"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31.418 31.418"
    >
      <g>
        <path
          d="M26.586,15.708c0,0.909-0.41,1.766-1.117,2.335L9.715,30.753c-0.544,0.438-1.211,0.665-1.884,0.665
        c-0.439,0-0.882-0.099-1.293-0.293c-1.042-0.499-1.706-1.552-1.706-2.707V3c0-1.154,0.664-2.208,1.706-2.707
        c1.043-0.496,2.279-0.354,3.178,0.372l15.755,12.709C26.176,13.942,26.586,14.8,26.586,15.708z"
        />
      </g>
    </svg>
  );
};
const CheckSquareIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 13L10 16L17 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const TimeIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
        fill="currentColor"
      />
      <path
        d="M12 5C11.4477 5 11 5.44771 11 6V12.4667C11 12.4667 11 12.7274 11.1267 12.9235C11.2115 13.0898 11.3437 13.2343 11.5174 13.3346L16.1372 16.0019C16.6155 16.278 17.2271 16.1141 17.5032 15.6358C17.7793 15.1575 17.6155 14.5459 17.1372 14.2698L13 11.8812V6C13 5.44772 12.5523 5 12 5Z"
        fill="currentColor"
      />
    </svg>
  );
};
const EventIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 19.0052V4.99481C17.5 4.35586 16.7879 3.97474 16.2562 4.32917L14.9867 5.17551C14.6969 5.36876 14.3153 5.3522 14.0432 5.13457L12.4998 3.8998C12.2076 3.66606 11.7924 3.66607 11.5002 3.89981L9.95679 5.13457C9.68475 5.3522 9.30314 5.36876 9.01327 5.17551L7.74376 4.32917C7.21212 3.97474 6.5 4.35586 6.5 4.99481V19.0052C6.5 19.6441 7.21212 20.0253 7.74376 19.6708L9.01327 18.8245C9.30314 18.6312 9.68475 18.6478 9.95679 18.8654L11.5002 20.1002C11.7924 20.3339 12.2076 20.3339 12.4998 20.1002L14.0432 18.8654C14.3153 18.6478 14.6969 18.6312 14.9867 18.8245L16.2562 19.6708C16.7879 20.0253 17.5 19.6441 17.5 19.0052Z"
        stroke="currentColor"
      />
      <path d="M9.5 9.5H14.5" stroke="currentColor" strokeLinecap="round" />
      <path d="M9.5 12H14.5" stroke="currentColor" strokeLinecap="round" />
      <path d="M9.5 14.5H14.5" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
};

const InvitationIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M338.79-.011v527.66L-.034 821.298V1919.99h1920V821.297l-338.71-293.647V-.011H338.79Zm112.94 1203.953V112.93h1016.471v1091.012l-189.289 151.34H641.02l-189.29-151.34Zm1129.526-526.87 225.882 195.726v60.085l-225.882 180.706V677.07ZM112.907 932.881v-60.084L338.79 677.071v436.518L112.907 932.883Zm1694.23 144.678v623.323l-238.08-301.553-88.658 70.023 266.654 337.695H172.88l266.767-337.695-88.659-70.023-238.08 301.553V1077.56l488.47 390.777h717.29l488.47-390.777Zm-790.666-795.207v282.353h282.353v112.941H1016.47V960H903.529V677.647H621.176V564.706H903.53V282.353h112.942Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export {
  BellIcon,
  CalendarAddIcon,
  CalendarBackIcon,
  CalendarForwardIcon,
  CalendarAgendaIcon,
  CalendarDateIcon,
  CalendarDayIcon,
  CalendarMonthIcon,
  CalendarWeekIcon,
  CheckSquareIcon,
  EventIcon,
  TimeIcon,
  InvitationIcon,
};
